import { Button, Col, Row } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { AppHeader } from "../../components/Header/Header";
import logo from "../../assets/JomUntu Logo.png";
import logoRed from "../../assets/Group 1.png";
import Footer from "../../components/Footer/Footer";
import leftphone from "../../assets/left.png";
import rightphone from "../../assets/right.png";
import phoneHand from "../../assets/handphonenew.png";
import { useEffect, useState } from "react";
import CustomButton from "../../components/DownloadButton/DownloadButton";
import apple from "../../assets/Apple.png";
import playstore from "../../assets/Playstore.png";
import Arrow from "../../assets/UP.png";
import { useTranslation } from "react-i18next";

export const LandingPage = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div
        className="min-h-screen flex flex-col relative bg-customRedOrange"
      >
        <AppHeader />

        <section
          className="min-h-screen flex flex-col justify-center relative z-30"
          id="home"
        >
          <Row
            className="w-full max-w-6xl mx-auto px-4 sm:px-4 md:px-4 lg:px-4 xl:px-12 relative items-center mt-8 p-4 md:p-6"
            style={{ position: "relative" }}
          >
            <Row className="w-full max-w-6xl mx-auto px-4 flex justify-start items-center text-white pt-10">
              <Col
                xs={24}
                md={6}
                className="flex flex-col items-center md:items-start justify-start md:ml-40"
              >
                <h1
                  className="text-4xl md:text-6xl font-clash mb-4"
                  style={{
                    fontFamily: "Clash Grotesk",
                    fontWeight: 500,
                    lineHeight: "100%",
                  }}
                >
                  gRRRRR...
                </h1>
                <h2 className="flex items-center justify-center">
                  <img
                    src={logo}
                    alt="jomuntu logo"
                    className="w-[300px] md:w-[460px] h-auto"
                  />
                </h2>
              </Col>
            </Row>

            <div
              className="absolute left-0 right-0 bg-white rounded-[20px] border-[1px] border-solid border-gray-300
           h-[65%] sm:h-[65%] md:top-1/3 md:h-[45%] lg:top-1/3 lg:h-[45%] xl:top-1/3 xl:h-[45%]
           mx-4"
              style={{
                zIndex: -1,
              }}
            ></div>

            <Col
              xs={24}
              md={12}
              className="relative z-20 p-4 md:p-10 mt-10 sm:mt-5"
            >
              <div>
                <p
                  className="text-2xl md:text-4xl text-center md:text-left mb-4 md:mb-6"
                  style={{
                    fontFamily: "Clash Grotesk",
                    fontWeight: 500,
                    lineHeight: "1.2",
                  }}
                >
                  {t("landing.tagline1")}
                  <br />
                  <span className="inline-flex items-center">
                    <img
                      src={logoRed}
                      className="w-[100px] md:w-[150px] h-auto mr-2"
                      alt="jomuntu logo"
                    />
                    {t("landing.tagline2")}
                  </span>
                </p>
                <p
                  className="text-base md:text-2xl text-black mb-4 text-center md:text-left"
                  style={{
                    fontFamily: "Clash Grotesk",
                    fontWeight: 400,
                  }}
                >
                  {t("landing.download")}
                </p>

                <div className="flex flex-col items-center justify-center gap-4 md:flex-row md:justify-start sm:w-full">
                  <CustomButton
                    imageSrc={apple}
                    primaryText={t("landing.downloadApple")}
                    secondaryText="App Store"
                    onClick={() => console.log("Clicked!")}
                  />
                  <CustomButton
                    imageSrc={playstore}
                    primaryText={t("landing.downloadGoogle")}
                    secondaryText="Google Play"
                    onClick={() => console.log("Clicked!")}
                  />
                </div>

                <Button
                  type="text"
                  className="text-black font-clash flex items-center mt-4 mx-auto md:mx-0 text-lg md:text-2xl"
                  style={{
                    fontFamily: "Clash Grotesk",
                    fontWeight: 400,
                  }}
                >
                  {t("landing.visitWebsite")}{" "}
                  <ArrowRightOutlined className="ml-2" />
                </Button>
              </div>
            </Col>

            <Col
              xs={24}
              md={12}
              className="px-4 flex justify-center items-center mt-4 md:mt-0"
            >
              <div className="relative flex justify-center items-center mt-4 md:mt-0 overflow-hidden">
                <img
                  src={phoneHand}
                  alt="Phone Mockup"
                  className="w-auto h-[600px] sm:h-[600px] md:h-[800px] max-w-[1000px] sm:max-w-[600px] md:max-w-[1016px] object-cover"
                />
              </div>
            </Col>
          </Row>
        </section>
      </div>

      <section id="about">
        <div
          className="min-h-screen flex flex-col relative"
          style={{
            backgroundImage: " url('/Group 8.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="relative w-full min-h-screen bg-cover bg-center flex flex-col items-center justify-center gap-20">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-0 w-full justify-center relative">
              <img
                src={leftphone}
                alt="Phone 1"
                className="w-[400px] md:w-[500px] relative z-10"
              />
              <div className="bg-customRedOrange text-white p-8 rounded-lg shadow-lg relative z-0 md:ml-[-5rem] sm:mx-4">
                <p className="w-[250px] sm:w-[250px] md:w-[450px] text-2xl sm:text-3xl md:text-4xl font-semibold text-center md:text-right">
                  {t("landing.about1")}
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-0 w-full justify-center relative">
              <img
                src={rightphone}
                alt="Phone 2"
                className="w-[400px] md:w-[500px] relative z-10 order-1 md:order-2"
              />
              <div className="bg-customOrange text-white p-8 rounded-lg shadow-lg relative z-0 md:mr-[-8rem] order-2 md:order-1 sm:mb-6 mb-6 sm:mx-4">
                <p className="w-[250px] sm:w-[250px] md:w-[450px] text-2xl sm:text-3xl md:text-4xl font-semibold text-center md:text-right">
                  {t("landing.about2")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact">
        <Footer />
      </section>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-4 right-4 p-3 z-50"
          aria-label="Scroll to top"
        >
          <img src={Arrow} alt="Scroll to top" />
        </button>
      )}
    </>
  );
};
